<section class="bg-white">
  <div class="mx-auto max-w-300 px-6 py-9">
    <!-- Signature tricolore -->
    <div class="mb-2.5 flex h-1 w-7.5 gap-0.75" aria-hidden="true">
      <span class="flex-1 bg-(--cmr-vert)"></span>
      <span class="flex-1 bg-(--cmr-rouge)"></span>
      <span class="flex-1 bg-(--cmr-jaune)"></span>
    </div>

    <p class="m-0 text-xs font-bold uppercase tracking-[0.12em] text-(--text-muted)">{{ 'pages.home.agenda.eyebrow' | translate }}</p>
    <h1 class="mb-6 mt-2 text-3xl font-extrabold text-(--text-body)">{{ 'pages.home.agenda.title' | translate }}</h1>

    <form (submit)="$event.preventDefault(); applyQuery()" class="mb-4 flex flex-wrap items-center gap-3">
      <label for="event-search" class="sr-only">{{ 'events.list.searchLabel' | translate }}</label>
      <input id="event-search" type="search" [placeholder]="('events.list.searchPlaceholder' | translate) + '…'" [value]="query()"
        (input)="query.set($any($event.target).value)"
        class="box-border h-11 min-w-0 flex-1 rounded-sm border border-(--border-input) bg-white px-3.5 text-[14.5px] text-(--text-body) outline-none focus:border-(--brand-primary) focus:shadow-(--focus-ring)" />
      <button type="submit"
        class="box-border h-11 shrink-0 cursor-pointer rounded-sm border-0 bg-(--brand-primary) px-5 text-[14px] font-bold text-white transition hover:bg-(--brand-primary-hover)">
        {{ 'common.search' | translate }}
      </button>
    </form>

    <div class="mb-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
      <select [value]="regionFilter()" (change)="setRegion($any($event.target).value)"
        class="box-border h-10 w-full rounded-sm border border-(--border-input) bg-white px-2.5 text-[13.5px] text-(--text-body) outline-none focus:border-(--brand-primary) focus:shadow-(--focus-ring)">
        <option value="">{{ 'events.list.allRegions' | translate }}</option>
        @for (code of regionOptions(); track code) {
          <option [value]="code">{{ ('regions.' + code) | translate }}</option>
        }
      </select>

      <select [value]="cityFilter()" (change)="setCity($any($event.target).value)"
        class="box-border h-10 w-full rounded-sm border border-(--border-input) bg-white px-2.5 text-[13.5px] text-(--text-body) outline-none focus:border-(--brand-primary) focus:shadow-(--focus-ring)">
        <option value="">{{ 'events.list.allCities' | translate }}</option>
        @for (city of cityOptions(); track city) {
          <option [value]="city">{{ cityLabel(city) }}</option>
        }
      </select>

      <select [value]="eventTypeFilter()" (change)="setEventType($any($event.target).value)"
        class="box-border h-10 w-full rounded-sm border border-(--border-input) bg-white px-2.5 text-[13.5px] text-(--text-body) outline-none focus:border-(--brand-primary) focus:shadow-(--focus-ring)">
        <option value="">{{ 'events.list.allFormats' | translate }}</option>
        @for (type of eventTypeOptions(); track type) {
          <option [value]="type">{{ eventTypeLabel(type) }}</option>
        }
      </select>

      <select [value]="categoryFilter()" (change)="setCategory($any($event.target).value)"
        class="box-border h-10 w-full rounded-sm border border-(--border-input) bg-white px-2.5 text-[13.5px] text-(--text-body) outline-none focus:border-(--brand-primary) focus:shadow-(--focus-ring)">
        <option value="">{{ 'events.list.allCategories' | translate }}</option>
        @for (category of categoryOptions(); track category) {
          <option [value]="category">{{ categoryLabel(category) }}</option>
        }
      </select>

      <button type="button" (click)="resetFilters()"
        class="box-border h-10 cursor-pointer rounded-sm border border-(--border-strong) bg-white px-3.5 text-[13px] font-bold text-(--text-muted) transition hover:border-(--pnud-bleu) hover:text-(--pnud-bleu)">
        {{ 'events.list.reset' | translate }}
      </button>
    </div>

    <p class="mb-4 text-[13px] text-(--text-muted)" aria-live="polite">
      <strong>{{ totalElements() }}</strong> {{ 'events.list.eventCountSuffix' | translate }}
    </p>

    @if (loading()) {
      <p class="py-8 text-center text-[13.5px] text-(--text-muted)" aria-live="polite">{{ 'events.list.loading' | translate }}</p>
    } @else if (error()) {
      <p class="py-8 text-center text-[13.5px] text-(--state-danger)" role="alert">
        {{ 'events.list.loadError' | translate }}
      </p>
    } @else {
      <div class="grid grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-4">
        @for (event of events(); track event.id; let i = $index) {
          <div [appScrollReveal]="i">
            <app-event-card [event]="event" (open)="openEvent($event)" />
          </div>
        } @empty {
          <p class="col-span-full py-8 text-center text-[13.5px] text-(--text-muted)">
            {{ 'events.list.noResults' | translate }}
          </p>
        }
      </div>

      @if (totalPages() > 1) {
        <div class="mt-6 flex flex-wrap items-center justify-end gap-2">
          <button type="button"
            class="cursor-pointer rounded-full border border-(--border-strong) bg-white px-3.5 py-2 text-[13px] font-bold text-(--text-muted) disabled:cursor-not-allowed disabled:opacity-50"
            [disabled]="page() === 0" (click)="previousPage()">
            {{ 'common.previous' | translate }}
          </button>
          <span class="text-[13px] text-(--text-muted)" aria-live="polite">{{ 'events.list.pageOf' | translate: { page: page() + 1, total: totalPages() } }}</span>
          <button type="button"
            class="cursor-pointer rounded-full border border-(--border-strong) bg-white px-3.5 py-2 text-[13px] font-bold text-(--text-muted) disabled:cursor-not-allowed disabled:opacity-50"
            [disabled]="page() + 1 >= totalPages()" (click)="nextPage()">
            {{ 'common.next' | translate }}
          </button>
        </div>
      }
    }
  </div>
</section>
